import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {AlbumEndpoint} from '../_constants/api.constant'
export async function updateAlbum(albumId,dataObj) {
    const response = await axios.put(
        AlbumEndpoint.UPDATE_ALBUM+albumId+"/",
        dataObj,
        {   params:{},
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}